interface ValidateSubmitProps {
    initialValues?: {
        displayName: string;
        isPublic: boolean;
        feedStatus?: {
            showInFeed: boolean;
        };
    };
    values: {
        collectionName: string;
        isPublic: boolean;
        showInFeed: boolean;
        currentSuggest: string;
    };
}

export const validateSubmit = ({ initialValues, values }: ValidateSubmitProps) => {
    const displayName =
        values.showInFeed && values.currentSuggest ? values.currentSuggest : values.collectionName;

    const hasChanges =
        initialValues?.displayName !== displayName ||
        initialValues?.isPublic !== values.isPublic ||
        initialValues.feedStatus?.showInFeed !== values.showInFeed;

    return hasChanges;
};
